// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--bcURb";
export var title = "index-module--title--KXL1H";
export var button = "index-module--button--bUHgF";
export var description = "index-module--description--vaTJJ";
export var base = "index-module--base--3+Ff1";
export var avatar = "index-module--avatar--leJCa";
export var gallery = "index-module--gallery--NRHki";
export var item = "index-module--item--QosGN";